import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

declare var bootbox:any;

@Component({
  selector: 'app-organization-management',
  template: require('./organization-management.component.html')
})
export class OrganizationManagementComponent extends BaseComponent implements OnInit {
  
  public organization = {
      name:"",
      isDemo: 0
  };
  public departments = [];

  public organizationId = -1;

  ngOnInit() {
    super.ngOnInit();
  }

  routeParamsUpdated() {
    this.organizationId = this.currentRouteParams["orgId"];
    this.loadOrganization();
  }

  public loadOrganization() {
    this.busy = this.lsApi.getOrganizationById(this.organizationId).subscribe(resp => {
        if(resp.status) {
            this.organization = resp.data[0];
            this.loadDepartments();
        }
    },
    error => {
        console.log(error);
    });
  }


  public loadDepartments() {
    this.busy = this.lsApi.getDepartments(this.organizationId).subscribe(resp => {
        if(resp.status) {
            this.departments = resp.data;
            if(this.departments.length>0) {
              this.initDataTable(
                "#tblData",
                [
                  { "bSearchable": true },  //col 2
                  { "bSearchable": true },  //col 3
                  { "bSearchable": false, bSortable: false } //col 1
                ],0
              );
            }
        }
    },
    error => {
        console.log(error);
    });
  }

  public deleteDepartment(dept) {
    
    
    bootbox.confirm({message:"Do you want to delete '" + dept.name + "' department?",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteDepartmentById(dept.departmentId).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Department Successfully Deleted","Department Deleted");
                this.loadDepartments();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});

  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organization-management/organization-management.component.ts